import $ from "jquery";
import { renderBootstrapErrors } from "./util/render_bootstrap_errors";
import { ajaxFormErrors } from "./util/ajax_form_errors.mjs";
import toastr from "toastr";

const formSuccess = function (/*e, data, status, xhr*/) {
  $("#contactModal").modal("hide");
  toastr.info("Message successfully sent");
};

const formError = function (e, xhr) {
  const errors = ajaxFormErrors(xhr);
  if (!errors) {
    toastr.error("Something went wrong. Please try again.");
    return;
  }

  renderBootstrapErrors($(this), errors);
};

$(document).on("turbolinks:load", function () {
  $("#new_contact_message")
    .on("ajax:success", formSuccess)
    .on("ajax:error", formError);
});
